import { Link } from 'react-router-dom';

const entries = [
  {
    title: '电影频道',
    desc: '汇聚最新与经典电影资源，剧情、动作、科幻一网打尽。',
    to: '/category/movie',
    icon: 'ri-film-line',
    count: '8 部在列',
  },
  {
    title: '电视剧频道',
    desc: '热播剧集持续更新，古装、都市、悬疑任你挑选。',
    to: '/category/tv',
    icon: 'ri-live-line',
    count: '6 部在列',
  },
  {
    title: '苹果视频',
    desc: '新品发布、专业评测与使用教程，苹果资讯一站直达。',
    to: '/category/apple',
    icon: 'ri-apple-fill',
    count: '10 部在列',
  },
];

export default function CategoryEntries() {
  return (
    <section className="px-4 py-12 md:px-8 md:py-16" aria-label="分类快捷入口">
      <div className="mb-8 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            快速进入频道
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            三大内容板块，按你的兴趣直接开始浏览。
          </p>
        </div>
        <Link
          to="/search?q=推荐"
          className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          查看全部内容
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-6">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group flex flex-col rounded-lg border border-background-200/80 bg-background-50 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 md:p-6"
          >
            <div className="mb-4 flex items-center justify-between">
              <span className="flex h-14 w-14 items-center justify-center rounded-lg bg-primary-50 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${entry.icon} text-2xl`} aria-hidden="true" />
              </span>
              <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
                {entry.count}
              </span>
            </div>
            <h3 className="mb-2 font-heading text-lg font-bold text-foreground-950">
              {entry.title}
            </h3>
            <p className="text-sm leading-relaxed text-foreground-600">
              {entry.desc}
            </p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-accent-600">
              进入频道
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}